import React, { useEffect } from "react";
import GooglePlayButton from "./GooglePlayButton";
import AppStoreButton from "./AppStoreButton";

const Download = () => {
  const PLAY_STORE_URL =
    "https://play.google.com/store/apps/details?id=com.flateroo.flateroo";
  const APP_STORE_URL = "https://apps.apple.com/us/app/flateroo/id6683311358";

  useEffect(() => {
    // Detect user agent
    const userAgent = navigator.userAgent.toLowerCase();
    const isAndroid = /android/.test(userAgent);
    const isIOS = /iphone|ipad|ipod/.test(userAgent);

    // Auto-redirect based on device
    if (isAndroid) {
      window.location.href = PLAY_STORE_URL;
    } else if (isIOS) {
      window.location.href = APP_STORE_URL;
    }
  }, []);

  return (
    <div className="min-h-screen bg-[#1c1c1c] flex flex-col justify-center items-center px-4">
      <h1 className="font-gnarly-semibold text-white text-5xl md:text-7xl mb-8 text-center">
        Download Our App
      </h1>
      <div className="flex flex-wrap justify-center gap-4">
        <GooglePlayButton />
        <AppStoreButton />
      </div>
    </div>
  );
};

export default Download;
